// eslint-disable-next-line import/prefer-default-export
export const EVERGREEN_SHOP_BANER_IMAGES = {
  desktopImage:
    'https://static.fabfitfun.com/cms/HP_Banner_2880x900_W2_copy_8e8a435796.jpg',
  tabletImage: 'https://static.fabfitfun.com/cms/HP_Tablet_1_c9d1f4dffa.jpg',
  mobileImage: 'https://static.fabfitfun.com/cms/HP_Mobile_d768908379.jpg',
};
